import { render } from "./Numbers.vue?vue&type=template&id=3276559c&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"

import "./Numbers.vue?vue&type=style&index=0&id=3276559c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276559c"]])

export default __exports__